(() => {
  var __defProp = Object.defineProperty;
  var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
  var __publicField = (obj, key, value) => {
    __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
    return value;
  };

  // src/js/components/language.js
  var _Language = class {
    static init() {
      const switchers = window.Store.app.theBody.querySelectorAll(_Language.param.selector);
      let objects = [];
      if (!switchers.length) {
        return null;
      }
      switchers.forEach((switcher) => {
        const object = new _Language(switcher);
        object.init();
        objects.push(object);
      });
      return objects;
    }
    constructor(element) {
      this.element = element;
    }
    init() {
      this.initListeners();
      this.update();
    }
    initListeners() {
      this.element.addEventListener("change", this.goToPage);
    }
    update() {
      const languages = window.Store.app.theContainer.getAttribute("data-pll-languages") ?? null;
      let json;
      if (!languages) {
        return false;
      }
      try {
        json = JSON.parse(languages);
      } catch (e) {
        console.log(e);
      }
      for (let lang of this.element.options) {
        const slug = lang.dataset.switcherSlug;
        lang.value = json[slug].url;
      }
      return true;
    }
    goToPage(event) {
      const slug = event.target.value;
      let url;
      if (!slug) {
        return false;
      }
      url = new URL(`${slug}`);
      window.location = url.href;
    }
  };
  var Language = _Language;
  __publicField(Language, "param", {
    selector: ".js-languageSwitcher"
  });
  function render() {
    window.Store.components.language.obj = Language.init();
  }
  window.Store.components.language.render = render;
})();
